import { createAction, props } from '@ngrx/store';
import { Customer } from '@oneqrew-partnertool/models';

export const setCustomer = createAction('[Customer] Set Customer', props<Customer>());
